import React from 'react'
import { useNavigate } from 'react-router-dom'
import classNames from 'classnames'
import { useGlobalContext } from 'src/stores/GlobalContext'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'
import HorizontalLine from 'src/components/Elements/HorizontalLine'
import Button from 'src/components/Elements/Button'
import UserRow from 'src/components/Elements/UserRow'
import useFetchSponsors from 'src/queries/sponsors/useFetchSponsors'
import partnerStyles from './partnerStyles.module.scss'

const PartnerDetailPage = () => {
  const { partnerId, eventId, currentEvent, attendees } = useGlobalContext()
  const { partner } = useFetchSponsors(partnerId)
  const navigate = useNavigate()
  const handleWebsiteClick = () => {
    window.open(partner.url)
  }
  const handleContactClick = (userId) => {
    navigate(`/programs/${eventId}/attendees/${userId}`)
  }
  let partnerDescription = partner?.description
  if (partnerDescription) {
    partnerDescription = partnerDescription.replaceAll(
      '<p>',
      '<p style="font-style: normal; font-weight: normal; font-size: 15px; line-height: 21px; letter-spacing: 0px; color: #000000;">'
    )
  }
  return (
    <div className={generalStyles.thirdWidth}>
      <div className={partnerStyles.partnerHeader}>
        <div
          className={classNames(generalStyles.flexColumn, generalStyles.pt40)}
        >
          <span className={fontStyles.h4lsgartnersans23pt}>
            {partner?.sponsor_type_name}
          </span>
          <div style={{ marginTop: '26px' }}>
            <img src={partner?.logo} className={partnerStyles.detailLogo} />
          </div>
        </div>

        <div className={generalStyles.mt40}>
          <HorizontalLine fullWidth={true} color={'neutral03e1e8f4'} />
        </div>
        <div className={generalStyles.mt20}>
          <Button
            color={'lightBase'}
            label={'View Website'}
            size={'large'}
            onClick={() => {
              handleWebsiteClick()
            }}
          />
        </div>
        <div className={generalStyles.mt20}>
          <HorizontalLine fullWidth={true} color={'neutral03e1e8f4'} />
        </div>
      </div>

      <div style={{ marginTop: '50px' }}>
        <span className={fontStyles.h5lsgartnersans20pt}>Overview</span>
        <div className={generalStyles.mt10} style={{ paddingBottom: '5px' }}>
          <HorizontalLine fullWidth={true} color={'neutral03e1e8f4'} />
        </div>
      </div>
      <div dangerouslySetInnerHTML={{ __html: partnerDescription }} />
      {currentEvent?.is_attended && partner?.sponsor_contacts?.length > 0 && (
        <>
          <div className={generalStyles.mt40}>
            <span className={fontStyles.h5lsgartnersans20pt}>Contacts</span>
            <div className={classNames(generalStyles.mt10, generalStyles.mb10)}>
              <HorizontalLine fullWidth={true} color={'neutral03e1e8f4'} />
            </div>
          </div>
          {partner.sponsor_contacts.map((contact) => {
            const user = attendees.find((a) => a.user_id === contact.user_id)
            return (
              <div key={user.user_id}>
                <button
                  key={`button-${user.user_id}`}
                  className={generalStyles.userRowButton}
                  onClick={() => handleContactClick(user.user_id)}
                >
                  <UserRow user={user} isSmallPhoto={true} />
                </button>
                <div
                  className={classNames(generalStyles.mt10, generalStyles.mb10)}
                >
                  <HorizontalLine fullWidth={true} color={'neutral03e1e8f4'} />
                </div>
              </div>
            )
          })}
        </>
      )}
    </div>
  )
}

export default PartnerDetailPage
